import { IRoute } from "./types";

export const HOME_ROUTE: IRoute = {
    name: 'Главная',
    path: '/',
}

export const MY_ROUTE: IRoute = {
    name: 'Мой профиль',
    path: '/my',
}

// AUTH

export const AUTH_ROUTE: IRoute = {
    name: 'Вход',
    path: '/auth'
}

export const LOGIN_ROUTE: IRoute = {
    name: 'Вход',
    path: '/auth/login'
}

export const REGISTRATION_ROUTE: IRoute = {
    name: 'Вход',
    path: '/auth/registration'
}



// TUTOR

export const TUTOR_LESSONS_ROUTE: IRoute = {
    name: 'Занятия',
    path: '/tutor_lessons'
}

export const TUTOR_ACCRUALS_ROUTE: IRoute = {
    name: 'Выплаты',
    path: '/tutor_accruals'
}

export const TUTOR_FINANCE_ROUTE: IRoute = {
    name: 'Финансы',
    path: '/tutor_finance'
}



// STUDENTS

export const STUDENTS_ROUTE: IRoute = {
    name: 'Студенты',
    path: '/students'
}

export const STUDENTS_ARCHIVE_ROUTE: IRoute = {
    name: 'Архив студентов',
    path: '/students/archive'
}

export const STUDENT_TAGS_ROUTE: IRoute = {
    name: 'Теги студентов',
    path: '/students_tags'
}

export const WORK_TGS_ROUTE: IRoute = {
    name: 'Рабочие ТГ',
    path: '/work_tgs'
}

export const TEAMS_ROUTE: IRoute = {
    name: 'Звенья',
    path: '/teams'
}

export const TEAM_ROUTE: IRoute = {
    name: 'Звено',
    path: '/teams/:id'
}

export const STAFF_ROUTE: IRoute = {
    name: 'Работники',
    path: '/staff'
}

export const STAFF_ARCHIVE_ROUTE: IRoute = {
    name: 'Архив работников',
    path: '/staff/archive'
}

export const PERFORMERS_ROUTE: IRoute = {
    name: 'Исполнители',
    path: '/performers'
}

export const PERFORMERS_ARCHIVE_ROUTE: IRoute = {
    name: 'Архив исполнителей',
    path: '/performers/archive'
}

export const STAFF_DOCUMENTS_ROUTE: IRoute = {
    name: 'Документы сотрудников',
    path: '/staff/documents',
}

export const STAFF_USER_ROUTE: IRoute = {
    name: 'Профиль',
    path: '/staff/:user_id'
}

export const STAFF_IDM_ROUTE: IRoute = {
    name: 'Права и доступы',
    path: '/staff/:user_id/idm'
}

export const STAFF_HISTORY_ROUTE: IRoute = {
    name: 'История изменений',
    path: '/staff/:user_id/history'
}

export const STAFF_PAYMENT_DETAILS_ROUTE: IRoute = {
    name: 'Реквизиты',
    path: '/staff/:user_id/payment-details'
}

export const STAFF_UPDATE_ROUTE: IRoute = {
    name: 'Редактирование сотрудника',
    path: '/staff/:user_id/update'
}

export const IDM_ROUTE: IRoute = {
    name: 'Права сотрудников',
    path: '/idm'
}

export const IDM_CREATE_ROUTE: IRoute = {
    name: 'Создать сотрудника',
    path: '/idm/create'
}

export const IDM_STAFF_ROUTE: IRoute = {
    name: 'Права сотрудников',
    path: '/idm/:id'
}

export const IDM_ROLES_ROUTE: IRoute = {
    name: 'Справочник ролей',
    path: '/idm/roles'
}

export const IDM_FEATURES_ROUTE: IRoute = {
    name: 'Справочник фичей',
    path: '/idm/features'
}

export const STUDENT_CREATE_ROUTE: IRoute = {
    name: 'Студенты',
    path: '/student/create'
}

export const STUDENT_PAYMENT_ROUTE: IRoute = {
    name: 'Оплата',
    path: '/payment/:hash'
}

export const STUDENT_UPDATE_ROUTE: IRoute = {
    name: 'Студенты',
    path: '/student/update'
}

export const STUDENT_ROUTE: IRoute = {
    name: 'Студент',
    path: '/students/:id'
}

export const STUDENT_HISTORY_ROUTE: IRoute = {
    name: 'История изменений',
    path: '/students/:id/history'
}

export const STUDENT_WALLET_HISTORY_ROUTE: IRoute = {
    name: 'Изменение кошелька',
    path: '/students/:id/wallet-history'
}



// ADMIN

export const ADMINS_ROUTE: IRoute = {
    name: 'Админы',
    path: '/admins'
}

export const ADMIN_ROUTE: IRoute = {
    name: 'Админ',
    path: '/admin/:id'
}

export const ADMIN_CREATE_ROUTE: IRoute = {
    name: 'Админы',
    path: '/admin/create'
}



// ASSISTANT

export const ASSISTANTS_ROUTE: IRoute = {
    name: 'Ассистенты',
    path: '/assistants'
}

export const ASSISTANT_ROUTE: IRoute = {
    name: 'Ассистент',
    path: '/assistant/:id'
}

export const ASSISTANT_CREATE_ROUTE: IRoute = {
    name: 'Ассистенты',
    path: '/assistant/create'
}




export const THANK_YOU_ROUTE: IRoute = {
    name: 'Спасибо',
    path: '/spasibo'
}

export const ADMIN_TRANSACTIONS_ROUTE: IRoute = {
    name: 'Транзакции',
    path: '/transactions'
}

export const ADMIN_LESSONS_ROUTE: IRoute = {
    name: 'Занятия',
    path: '/lessons'
}

export const FINANCE_ROUTE: IRoute = {
    name: 'Финансы',
    path: '/finance'
}

export const FINANCE_DOCUMENTS_ROUTE: IRoute = {
    name: 'Документы',
    path: '/finance/documents'
}

export const CALENDAR_ROUTE: IRoute = {
    name: 'Календарь',
    path: '/calendar'   
}

export const CALENDAR_TRIAL_ROUTE: IRoute = {
    name: 'Пробные занятия',
    path: '/calendar/trial'
}

export const CALENDAR_SHIFT_ROUTE: IRoute = {
    name: 'Календарь смен',
    path: '/shifts'
}

export const CALENDAR_SHIFT_DAY_ROUTE: IRoute = {
    name: 'Смена на день',
    path: '/shifts/day/:date'
}

export const EVENTS_ROUTE: IRoute = {
    name: 'События',
    path: '/events'
}

export const STATISTICS_ROUTE: IRoute = {
    name: 'Статистика',
    path: '/statistics'
}

export const LEGAL_INFO_ROUTE: IRoute = {
    name: 'Юр. информация',
    path: '/legal-info'
}

export const CALENDAR_DAY_ROUTE: IRoute = {
    name: 'Расписание на день',
    path: '/calendar/day/:date'
}

export const CALENDAR_LESSON_ROUTE: IRoute = {
    name: 'Занятие',
    path: '/calendar/day/:date/lesson/:lessonId'
}

export const CALENDAR_TRIAL_DAY_ROUTE: IRoute = {
    name: 'Пробные на день',
    path: '/calendar/trial/day/:date'
}

export const CALENDAR_TRIAL_LESSON_ROUTE: IRoute = {
    name: 'Пробное занятие',
    path: '/calendar/trial/day/:date/lesson/:lessonId'
}
